const gtag = globalThis.gtag;

export { gtag };
